<template>
    <FormButton @click="toggleState" :variant="variant">
        <Icon class="mr-2 h-3 w-3 text-inherit" :icon="icon" v-if="!loading" />
        {{ text }}</FormButton
    >
</template>

<script>
import { CampaignStoreNamespacedTypes } from "@/store/modules/campaign";

import Bus from "@/bus";
import Icon from "@/components/icons/BaseIcon";
import { IconEnums } from "@/utils/icons";
import FormButton, {
    ButtonVariants,
} from "@/components/forms/fields/FormButton";
import { getProperty } from "@/utils/object";

export default {
    components: { Icon, FormButton },
    data: () => ({
        ButtonVariants,
        IconEnums,
    }),
    computed: {
        /**
         * @type {Boolean}
         */
        loading() {
            return this.$store.getters[
                CampaignStoreNamespacedTypes.getters.CAMPAIGNS_LOADING
            ]();
        },

        /**
         * @type {Object}
         */
        error() {
            return this.$store.getters[
                CampaignStoreNamespacedTypes.getters.CAMPAIGNS_ERROR
            ]();
        },

        /**
         * @type {Array}
         */
        campaign() {
            return this.$store.getters[
                CampaignStoreNamespacedTypes.getters.CAMPAIGN
            ]();
        },

        /**
         * @type {string}
         */
        id() {
            return getProperty(this.campaign, "id", null);
        },

        /**
         * @type {string}
         */
        status() {
            return getProperty(this.campaign, "status", "running");
        },

        /**
         * @type {Boolean}
         */
        isRunning() {
            return this.status === "running";
        },

        /**
         * @type {string}
         */
        variant() {
            return this.isRunning
                ? ButtonVariants.WARNING
                : ButtonVariants.PRIMARY;
        },

        /**
         * @type {Object}
         */
        icon() {
            return this.isRunning ? IconEnums.PAUSE : IconEnums.PLAY;
        },

        /**
         * @type {string}
         */
        text() {
            return this.isRunning
                ? this.$t("simulations.pause")
                : this.$t("simulations.play");
        },
    },
    methods: {
        toggleState() {
            this.$store
                .dispatch(
                    CampaignStoreNamespacedTypes.actions.TOGGLE_CAMPAIGN_STATE,
                    this.id
                )
                .then(() => {
                    Bus.$emit("flash-message", {
                        text: this.$t("simulations.campaign_updated"),
                        type: "success",
                    });
                });
        },
    },
};
</script>
